import React, { useState } from 'react';
type SmartImageProps = {
  src: string;
  alt: string;
  className?: string;
  wrapperClassName?: string;
  width?: number;
  height?: number;
  priority?: boolean;
};

/**
 * Image with a graphite placeholder and a soft fade-in, so heavy artwork
 * never leaves an empty white gap while it downloads.
 */
export function SmartImage({
  src,
  alt,
  className = '',
  wrapperClassName = '',
  width,
  height,
  priority = false
}: SmartImageProps) {
  const [loaded, setLoaded] = useState(false);
  return <span className={`relative block overflow-hidden ${wrapperClassName}`} data-id="element-340" data-mp="16vn4z1vapqqc">
      {!loaded ? <span aria-hidden="true" className="absolute inset-0 animate-pulse bg-anthracite" data-id="element-341" data-mp="1lkjgxa0h3nw8" /> : null}
      <img src={src} alt={alt} width={width} height={height} loading={priority ? 'eager' : 'lazy'} decoding={priority ? 'sync' : 'async'}
    // @ts-expect-error fetchpriority is a valid DOM attribute
    fetchpriority={priority ? 'high' : 'low'} onLoad={() => setLoaded(true)} className={`relative transition-opacity duration-700 ${loaded ? 'opacity-100' : 'opacity-0'} ${className}`} data-id="element-342" data-mp="1gqoptlijg6n4" />
    </span>;
}